'use strict';

module Patersons {

    // NOTE: In the UI templates, these are referred to as 'Contract Notes'.
    export interface ConfirmationNotesScope extends ng.IScope {
        accounts: Array<Account>;
        selectedAccount: Account;
        selectedAccountTotals: SelectedAccountTotal;
        events: ConfirmationNotesCtrl;
        generatedDate: Date;
        reportError: string;
        isLoading: boolean;
        isSelected: boolean;
        isSelectAll: boolean;
        reverse: boolean;
        predicate: string;
        startDate: Date;
        endDate: Date;
        checkedItems: Array<any>;
        filter: ng.IFilterService;
        isDownloadReady: boolean;
        isDownloading: boolean;
        hasData: boolean;
        isError: boolean;
    }

    //export class ConfirmationNotesCtrl extends AbstractController {
    export class ConfirmationNotesCtrl extends PortfolioBaseCtrl {
        q: ng.IQService;
        state: angular.ui.IStateService;
        http: ng.IHttpService;
        scope: Patersons.ConfirmationNotesScope;
        portfolioService: Patersons.PortfolioService;
        bulkDownloadService: Patersons.BulkDownloadService;
        pdfBuilderService: Patersons.PDFBuilderService;
        static $inject = ['$q', '$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'bulkDownloadService','navigationService', 'pdfBuilderService'];

        constructor($q, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, bulkDownloadService, navigationService, pdfBuilderService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.q = $q;
            this.state = $state;
            this.http = $http;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.filter = $filter;
            this.portfolioService = portfolioService;
            this.bulkDownloadService = bulkDownloadService;
            this.pdfBuilderService = pdfBuilderService;
            this.scope.accounts = new Array<Account>();
            this.scope.reverse = true;
            this.scope.predicate = "conDate";
            this.scope.isSelectAll = false;

            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();

            this.scope.generatedDate = new Date();
            this.scope.hasData = false;
            this.scope.isError = false;

            this.load();
        }


        order = function (predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        };

        hasNotesInRange(): boolean {
            let start: moment.Moment = moment(this.scope.startDate);
            let end: moment.Moment = moment(this.scope.endDate);

            return this.scope.selectedAccount &&
                this.scope.selectedAccount.confirmationNotes &&
                this.scope.selectedAccount.confirmationNotes.some(m => moment(m.conDate).isBetween(start, end, 'days', '[]'));
        }

        selectAll(e) {
            e.stopPropagation();
            this.scope.isSelectAll = !this.scope.isSelectAll;
            var selectAll = this.scope.isSelectAll;
            console.log("Selected : " + selectAll);
            var log = [];

            let selectableContractNotes = this.scope.selectedAccount.confirmationNotes.filter(x => x.uri !== null);

            angular.forEach(selectableContractNotes, function (cn, key) {
                cn.isSelected = selectAll;
                console.log("Set : " + cn.isSelected);
            });

            if (selectAll === true) {
                this.scope.checkedItems = selectableContractNotes;
            } else {
                this.scope.checkedItems = [];
            }
        };

        isDownloadButtonDisabled() {
            return this.scope.checkedItems == undefined || this.scope.checkedItems.length <= 0;
        }

        toggleSelection(item, e) {
            e.stopPropagation();
            if (this.scope.checkedItems == undefined) {
                this.scope.checkedItems = [];
            }
            var idx = this.scope.checkedItems.indexOf(item);

            if (idx > -1) {
                this.scope.checkedItems.splice(idx, 1);
            }
            else {
                this.scope.checkedItems.push(item);
            }
        };

        load() {
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then((result) => {
                    this.scope.$apply(() => {
                        this.scope.accounts = result;
                        this.scope.isLoading = false;
                    });
                });
        }

        loadConfirmationNotes(accountId: string, startDate: Date, endDate: Date) {

            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
            this.scope.startDate = startDate;
            this.scope.endDate = endDate;
            this.scope.generatedDate = new Date();

            this.scope.isLoading = true;
            this.scope.isDownloadReady = false;

            this.scope.hasData = false;
            this.scope.isError = false;

            this.portfolioService.getContractNotes(this.scope.selectedAccount.accountId, startDate, endDate)
                .then((result) => {
                    this.scope.selectedAccount.confirmationNotes = result;
                    this.scope.isDownloadReady = true;
                    this.scope.hasData = true;
                    this.scope.isError = false;
                },
                (reason) => {
                    this.scope.reportError = reason.data.message;
                    this.scope.hasData = false;
                    this.scope.isError = true;
                })
                .finally(() => {
                    this.scope.isLoading = false;
                });
        }

        downloadPdf() {
            console.info('Download PDF');
            let account = this.scope.selectedAccount;
            let startDate = this.scope.startDate;
            let endDate = this.scope.endDate;
            let fileName = this.getFileName(account.accountId, startDate, endDate);
            let filteredData = account.confirmationNotes;
            let sortedData = this.orderBy(filteredData, this.scope.predicate, this.scope.reverse);

            this.makePdf(sortedData, account, startDate, endDate, fileName + ".pdf");
        }

        downloadCsv() {
            console.info('Download CSV');
            let account = this.scope.selectedAccount;
            let startDate = this.scope.startDate;
            let endDate = this.scope.endDate;
            let fileName = this.getFileName(account.accountId, startDate, endDate);
            let filteredData = account.confirmationNotes;
            let sortedData = this.orderBy(filteredData, this.scope.predicate, this.scope.reverse);

            this.makeCsv(sortedData, account, startDate, endDate, fileName);
        }

        downloadContractNote(item: ConfirmationNote, e: ng.IAngularEvent) {
            this.http.get(item.uri, { headers: { 'Accept': 'application/pdf' }, responseType: 'arraybuffer'})
                .then((response) => {
                    var blob = new Blob([response.data], { type: 'application/pdf' });

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // Open BLOB in IE and Edge
                        window.navigator.msSaveOrOpenBlob(blob, item.prettyFileName);
                    }
                    else {
                        // Open BLOB in Chrome, Firefox etc.
                        var downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(blob);
                        downloadLink.target = '_blank';
                        downloadLink.setAttribute('download', item.prettyFileName);

                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        downloadLink.remove();
                    }
                },
                (reason) => {
                    if (reason.status === 403) {
                            this.state.go('forbidden');
                    }

                    throw reason;
                });
        }

        download() {
            if (this.scope.checkedItems == undefined || this.scope.checkedItems.length <= 0) {
                return null;
            }

            this.scope.isDownloading = true;
            let filename = this.scope.selectedAccount.accountId + "-" + moment(new Date()).format("YYYY-MM-DD") + ".zip";
            this.bulkDownloadService.downloadItems(this.scope.checkedItems, filename)
                .finally(() => {
                    this.scope.isDownloading = false;
                });
        }

        getSummaryText = function() {
            var text = "Report generated at " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                " AEST on " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
            return text;
        }

        private orderBy(notes: ConfirmationNote[], predicate: string, reverse: boolean): Array<any> {
            return this.scope.filter<any>('orderBy')(notes, predicate, reverse);
        }

        private makePdf(notes: ConfirmationNote[], account: Account, startDate: Date, endDate: Date, filename: string): any {
            filename = filename + ".pdf";
            let nowDate = moment(new Date());
            let formattedData = this.getFormattedData(notes);
            let startDateStr = moment(startDate).format("D MMM YYYY");
            let endDateStr = moment(endDate).format("D MMM YYYY");

            let generatedAt: string = moment.tz(nowDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');
            this.pdfBuilderService.newPdfBuilderInstance().then((pdfBuilder) => {
                pdfBuilder.setTitle('Contract Notes')
                    .setSubTitle(this.scope.filter<any>("accountName")(account.designation ? account.accountName+' '+account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:',account.adviserName, '','')
                    .addHeaderTableRow('Account:',account.accountId, '','')
                    .addHeaderTableRow('From:', startDateStr, '','')
                    .addHeaderTableRow('To:', endDateStr, '','')
                    .addHeaderTableRow('Report Generated At:', generatedAt, '', '')
                    .addTable('Contract Notes', formattedData, this.getFields(), this.getHeadings(), this.getFormatHints())
                    .setFilename(filename)
                    .build();
            })
        }

        private makeCsv(notes: ConfirmationNote[], account: Account, startDate: Date, endDate: Date, filename: string): void {
            filename = filename + ".csv";
            let formattedData = this.getFormattedDataCsv(notes);
            let topLine = ReportDownloadService.getCsvTopLine(account, new Date(), startDate, endDate, undefined);
            let csvBuilder = new CsvBuilder();
            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(formattedData)
                .build();
        }

        private getFormattedDataCsv(data: ConfirmationNote[]) {
            var formattedData = angular.copy(data);
            formattedData = formattedData.map<any>((note) => {
                const fields = this.getFields()
                const data = {
                    conNumber: note.conNumber,
                    conDate: moment(note.conDate).format("DD/MM/YYYY"),
                    securityCode: note.securityCode,
                    securityDescription: note.securityDescription,
                    type: note.type,
                    units: note.units,
                    currencyCode: note.currencyCode,
                    nett: note.nett
                };
                return fields.map(field => data[field])
            });

            return formattedData;
        }
        private getFormattedData(data: ConfirmationNote[]) {
            var formattedData = angular.copy(data);
            formattedData = formattedData.map<any>((note) => {
                return {
                    conNumber: note.conNumber,
                    conDate: moment(note.conDate).format("DD/MM/YYYY"),
                    securityCode: note.securityCode,
                    securityDescription: note.securityDescription,
                    type: note.type,
                    units: note.units,
                    currencyCode: note.currencyCode,
                    nett: note.nett
                };
            });

            return formattedData;
        }

        private getFileName(accountId: string, startDate: Date, endDate: Date): string {
            var startDateStr = moment(startDate).format("YYYY-MM-DD");
            var endDateStr = moment(endDate).format("YYYY-MM-DD");
            return accountId + "-ContractNotes-" + startDateStr + "_" + endDateStr;
        }

        private getFields() {
            return ["conDate", "conNumber", "type", "units", "securityCode", "securityDescription", "currencyCode", "nett"];
        }

        private getFormatHints() {
            return [
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.Currency
            ];
        }

        private getHeadings(): string[] {
            return ["Date", "Number", "Type", "Units", "Security Code", "Description", "Currency", "Nett"];
        }
    }
}
